import { BlackoutWheel } from "./BlackoutwheelClass";
import { WinScreen } from "./WinScreen";
// import {  resetAllBtns } from "../../globalFunctions";
// import { GameData } from "../../gamestate/gameData";
import {
  highlightJackpotBox,
  jackpotCoinsJump,
  displayJackpotBGCounter,
} from "../jackpotGlobalFunctions";
// import { getParameterByName } from "../../../common/getParameters";
import { createMovieClip } from "../../functions/Functions_General";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { Howl } from "howler";
import DeviceChecker from "../../functions/helper.ts/DeviceChecker";

export class JackpotWheel {
  private activeGameData: CommonData;
  private wheelContainer: PIXI.Container;
  private bigWheel: PIXI.Container;
  private smallWheel: PIXI.Container;
  private bigWheelSections: Array<PIXI.Sprite>;
  private smallWheelSections: Array<PIXI.Sprite>;
  private maxSpinDefault: number;
  private duration: number;
  private bigWheelMask: BlackoutWheel;
  private smallWheelMask: BlackoutWheel;
  private coreMask: BlackoutWheel;
  private spinSecondWheel: boolean;
  // private megapotExplosion:boolean;
  // private stopWheelSpin:boolean;
  private jackpotmegaJackpotText: PIXI.Sprite;
  private wheelFrame: PIXI.Container;
  private wheelFrameL: PIXI.Sprite;
  private wheelFrameR: PIXI.Sprite;
  private bigWheelTexture1: PIXI.Texture;
  // private bigWheelTexture2: PIXI.Texture;
  private smallWheelTexture1: PIXI.Texture;
  // private smallWheelTexture2: PIXI.Texture;
  private orbBroken: PIXI.Sprite;
  private orbDefaultAnimation: PIXI.extras.AnimatedSprite;
  private bigWheelArrowOn: PIXI.Sprite;
  private smallWheelArrowOn: PIXI.Sprite;
  private bigWheelArrowOnTween: PIXI.tween.Tween;
  private smallWheelArrowOnTween: PIXI.tween.Tween;
  private wheelGradientLightBig: PIXI.Sprite;
  private wheelGradientLightSmall: PIXI.Sprite;
  private pointerDefaultAnimation: PIXI.extras.AnimatedSprite;
  private explositonAnticipation: PIXI.Sprite;
  private explositonAnticipationTween: PIXI.tween.Tween;
  private midiStop: boolean;
  private megaStop: boolean;

  private arrowBigWheel: PIXI.extras.AnimatedSprite;
  private arrowSmallWheel: PIXI.extras.AnimatedSprite;
  private orbExplosionAnimation: PIXI.extras.AnimatedSprite;
  private orbExplosionAnimationTween: PIXI.tween.Tween;
  private tweeenAnticipation: PIXI.tween.Tween;
  private tweeenAction: PIXI.tween.Tween;
  private tweeenEnd: PIXI.tween.Tween;
  private wheelFrameIN: PIXI.tween.Tween;
  private wheelFrameOut: PIXI.tween.Tween;
  private wheelContainerIN: PIXI.tween.Tween;
  private wheelContainerOut: PIXI.tween.Tween;

  private sound_swoosh: Howl;
  private sound_arrowSound: Howl;
  private sound_glassBreak: Howl;

  private winScoreDisplay: WinScreen;

  constructor(activeGameData: any) {
    this.activeGameData = activeGameData;
    this.wheelContainer = new PIXI.Container(); //Parent of all elemets of wheel
    this.bigWheel = new PIXI.Container();
    this.smallWheel = new PIXI.Container();
    this.bigWheelSections = [];
    this.smallWheelSections = [];
    this.maxSpinDefault = 4;
    this.duration = 4000 * 3;
    this.bigWheelMask;
    this.smallWheelMask;
    this.coreMask;
    this.spinSecondWheel;
    // this.megapotExplosion=false;
    // this.stopWheelSpin=false;
    this.jackpotmegaJackpotText = new PIXI.Sprite(
      PIXI.Texture.fromImage("megaJackpotText.png")
    );
    this.wheelFrame = new PIXI.Container();
    this.wheelFrameL = new PIXI.Sprite(
      PIXI.Texture.fromImage("frameJackpot.png")
    );
    this.wheelFrameR = new PIXI.Sprite(
      PIXI.Texture.fromImage("frameJackpot.png")
    );
    this.bigWheelTexture1 = PIXI.Texture.fromImage("wheel2Jackpot.png");
    // this.bigWheelTexture2= PIXI.Texture.fromImage('wheel2JackpotOn.png');
    this.smallWheelTexture1 = PIXI.Texture.fromImage("wheel1Jackpot.png");
    // this.smallWheelTexture2= PIXI.Texture.fromImage('wheel1JackpotOn.png');
    this.orbBroken = new PIXI.Sprite(PIXI.Texture.fromImage("coreJackpot.png"));
    this.orbDefaultAnimation = createMovieClip("orb_default", 0, 26);
    this.bigWheelArrowOn = new PIXI.Sprite(
      PIXI.Texture.fromImage("wheel1JackpotOn.png")
    );
    this.smallWheelArrowOn = new PIXI.Sprite(
      PIXI.Texture.fromImage("wheel2JackpotOn.png")
    );
    this.bigWheelArrowOnTween = PIXI.tweenManager.createTween(
      this.bigWheelArrowOn
    );
    this.smallWheelArrowOnTween = PIXI.tweenManager.createTween(
      this.smallWheelArrowOn
    );
    this.wheelGradientLightBig = new PIXI.Sprite(
      PIXI.Texture.fromImage("lightWheel.png")
    );
    this.wheelGradientLightSmall = new PIXI.Sprite(
      PIXI.Texture.fromImage("lightWheel.png")
    );
    this.pointerDefaultAnimation = createMovieClip("pointer", 0, 26); //--Animated pointer on top of wheel
    this.pointerDefaultAnimation.animationSpeed = 0.4;

    this.explositonAnticipation = new PIXI.Sprite(
      PIXI.Texture.fromImage("jackpotLightSwipe.png")
    );
    this.explositonAnticipationTween = PIXI.tweenManager.createTween(
      this.explositonAnticipation
    );
    //Booleans
    this.midiStop;
    this.megaStop;

    this.winScoreDisplay = new WinScreen(this.activeGameData);

    this.arrowBigWheel = createMovieClip("arrow", 0, 26);
    this.arrowSmallWheel = createMovieClip("arrow", 0, 26);
    this.orbExplosionAnimation = createMovieClip("orb_Exp", 0, 14);

    this.orbExplosionAnimationTween = PIXI.tweenManager.createTween(
      this.orbExplosionAnimation
    );
    //WHEEL SPIN TWEENS
    this.tweeenAnticipation = PIXI.tweenManager.createTween(this.bigWheel); //Spring Back before start
    this.tweeenAction = PIXI.tweenManager.createTween(this.bigWheel); //Acutal Spin
    this.tweeenEnd = PIXI.tweenManager.createTween(this.bigWheel); //Spring Out

    //Animation IN OUT TWEENS
    this.wheelFrameIN = PIXI.tweenManager.createTween(this.wheelFrame);
    this.wheelFrameOut = PIXI.tweenManager.createTween(this.wheelFrame);
    this.wheelContainerIN = PIXI.tweenManager.createTween(this.wheelContainer);
    this.wheelContainerOut = PIXI.tweenManager.createTween(this.wheelContainer);

    this.sound_swoosh = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/24653905_swoosh.m4a?" + "version=" + activeGameData.gameVersion,
      ],
      volume: 1,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        // swoosh:[0 ,3000,false],
        swoosh: [0, 1202, false],
      },
    });
    this.activeGameData.soundList.push(this.sound_swoosh);

    this.sound_arrowSound = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/23566057_success.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],
      volume: 1,
      loop: false,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        arrow: [1, 15000, false],
      },
    });
    this.activeGameData.soundList.push(this.sound_arrowSound);

    this.sound_glassBreak = new Howl({
      html5: DeviceChecker.getInstance().checkIsAppleDevice(),
      src: [
        "sounds/20867478_glassBreak.m4a?" +
          "version=" +
          activeGameData.gameVersion,
      ],
      volume: 0.5,
      // loop:true,
      // preload:true,
      sprite: {
        // music: [0, 20869,true],
        // glassBreak:[200 ,1200,false],
        glassBreak: [0, 1875, false],
        // glassBreak:[0 ,2400,false],
      },
    });
    this.activeGameData.soundList.push(this.sound_glassBreak);

    this.createStart();
  }

  private createStart = (): void => {
    this.createWheel(
      this.bigWheelSections,
      36,
      10,
      this.bigWheel,
      this.bigWheelTexture1,
      0.016
    );
    this.createWheel(
      this.smallWheelSections,
      72,
      5,
      this.smallWheel,
      this.smallWheelTexture1,
      0.008
    );
    this.setInitailRotation();

    this.wheelFrameL.x = this.activeGameData.size[0] / 2 + 2;
    this.wheelFrameR.x = this.activeGameData.size[0] / 2 - 2;

    this.wheelFrameL.y =
      this.activeGameData.size[1] / 2 - this.wheelFrameL.height / 2 - 33.5;
    this.wheelFrameR.y =
      this.activeGameData.size[1] / 2 - this.wheelFrameL.height / 2 - 33.5;

    this.wheelFrameL.scale.set(-1, 1);

    this.wheelFrame.addChild(this.wheelFrameL);
    this.wheelFrame.addChild(this.wheelFrameR);

    this.orbDefaultAnimation.x =
      this.orbDefaultAnimation.width / 2 -
      (this.activeGameData.size[0] * 0.5) / 2 -
      1;
    this.orbDefaultAnimation.y =
      this.orbDefaultAnimation.height / 2 -
      (this.activeGameData.size[1] * 0.5) / 2 -
      75;

    this.orbExplosionAnimation.x = this.activeGameData.size[0] / 2;
    this.orbExplosionAnimation.y = this.activeGameData.size[1] / 2 - 80;
    this.orbExplosionAnimation.loop = false;

    this.orbBroken.x =
      this.activeGameData.size[0] / 2 - this.orbBroken.width / 2;
    this.orbBroken.y =
      this.activeGameData.size[1] / 2 - this.orbBroken.width / 2;
    this.pointerDefaultAnimation.x =
      this.activeGameData.size[0] / 2 - this.pointerDefaultAnimation.width / 2;
    this.pointerDefaultAnimation.y =
      this.activeGameData.size[1] / 2 -
      this.pointerDefaultAnimation.height / 2 -
      80;

    this.bigWheelMask = new BlackoutWheel(300, this.activeGameData);
    this.smallWheelMask = new BlackoutWheel(190, this.activeGameData);
    this.coreMask = new BlackoutWheel(105, this.activeGameData);

    this.arrowBigWheel.anchor.set(0.5);
    this.arrowBigWheel.y = this.activeGameData.size[1] / 2 + 77;
    this.arrowBigWheel.x = this.activeGameData.size[0] / 2 + 2;
    this.arrowSmallWheel.anchor.set(0.5);

    this.arrowSmallWheel.y = this.activeGameData.size[1] / 2 + 178;
    this.arrowSmallWheel.x = this.activeGameData.size[0] / 2 + 2;
    this.arrowBigWheel.animationSpeed = 1;
    this.arrowSmallWheel.animationSpeed = 1;
    this.arrowBigWheel.gotoAndStop(10);
    this.arrowSmallWheel.gotoAndStop(10);

    this.arrowBigWheel.alpha = 0;
    this.arrowSmallWheel.alpha = 0;

    this.orbExplosionAnimation.anchor.set(0.5);
    this.orbExplosionAnimationTween
      .from({ scale: { x: 1, y: 1 }, alpha: 1 })
      .to({ scale: { x: 4, y: 4 }, alpha: 0 });
    this.orbExplosionAnimationTween.time = 3000;
    this.orbExplosionAnimationTween.easing = PIXI.tween.Easing.outExpo();
    // this.orbExplosionAnimationTween.stop();

    this.explositonAnticipation.anchor.set(0.5);
    this.explositonAnticipation.x = this.activeGameData.size[0] / 2;
    this.explositonAnticipation.y = this.activeGameData.size[1] / 2;
    this.explositonAnticipation.scale.set(0);

    this.explositonAnticipationTween
      .from({ scale: { x: 5, y: 5 }, alpha: 0, rotation: 0 })
      .to({ scale: { x: 0, y: 0 }, alpha: 1, rotation: (Math.PI / 180) * 45 });
    this.explositonAnticipationTween.time = 2000;
    this.explositonAnticipationTween.easing = PIXI.tween.Easing.linear();
    // this.explositonAnticipationTween.start();
    // this.explositonAnticipationTween.loop=true;

    //Light effect oon wheel
    this.wheelGradientLightBig.anchor.set(0.5);
    // this.wheelGradientLightBig.scale.set(3.5);
    this.wheelGradientLightBig.x = this.activeGameData.size[0] / 2;
    this.wheelGradientLightBig.y = this.activeGameData.size[1] / 2;

    this.wheelGradientLightSmall.anchor.set(0.5);
    // this.wheelGradientLightSmall.scale.set(2.5);
    this.wheelGradientLightSmall.x = this.activeGameData.size[0] / 2;
    this.wheelGradientLightSmall.y = this.activeGameData.size[1] / 2;

    this.jackpotmegaJackpotText.anchor.set(0.5);
    this.jackpotmegaJackpotText.x = this.activeGameData.size[0] / 2;
    this.jackpotmegaJackpotText.y = this.activeGameData.size[1] / 2 - 75;
    this.jackpotmegaJackpotText.alpha = 0.5;

    this.smallWheelArrowOn.anchor.x = 0.008;
    this.smallWheelArrowOn.anchor.y = 0.999;
    this.smallWheelArrowOn.x = this.activeGameData.size[0] / 2;
    this.smallWheelArrowOn.y = this.activeGameData.size[1] / 2;
    this.smallWheelArrowOn.rotation = (-9 * Math.PI) / 180;
    this.smallWheelArrowOn.alpha = 0;

    this.bigWheelArrowOn.anchor.x = 0.016;
    this.bigWheelArrowOn.anchor.y = 0.999;
    this.bigWheelArrowOn.x = this.activeGameData.size[0] / 2;
    this.bigWheelArrowOn.y = this.activeGameData.size[1] / 2;
    this.bigWheelArrowOn.rotation = (Math.PI / 180) * -9;
    this.bigWheelArrowOn.alpha = 0;

    this.smallWheelArrowOnTween.from({ alpha: 0 }).to({ alpha: 1 });
    this.smallWheelArrowOnTween.time = 2000;
    this.smallWheelArrowOnTween.easing = PIXI.tween.Easing.outExpo();

    this.bigWheelArrowOnTween.from({ alpha: 0 }).to({ alpha: 1 });
    this.bigWheelArrowOnTween.time = 2000;
    this.bigWheelArrowOnTween.easing = PIXI.tween.Easing.outExpo();
  };

  private setInitailRotation = (): void => {
    this.bigWheel.rotation = (-9 * Math.PI) / 180; //Set initial wheel rotations
    this.smallWheel.rotation = ((-9 - 36) * Math.PI) / 180;
  };

  private getBigWheelStopAngle = (result: boolean): number => {
    let stopAngle = 0;

    if (result === false) {
      //if true => minipot
      stopAngle = 9;
    } else {
      //if true => midipot
      stopAngle = -9;
    }

    return stopAngle;
  };

  private getSmallWheelStopAngle = (result: boolean): number => {
    let stopAngle = 0;

    if (result === false) {
      //if true => midipot
      stopAngle = -9 - 36;
    } else {
      //if true => megapot
      stopAngle = -9;
    }

    return stopAngle;
  };

  // private setWheelStop = (midiBool: boolean, megaBool: boolean): void => {

  //     // let index:number=winIndex;
  //     this.midiStop = midiBool;
  //     this.megaStop = megaBool
  // }
  private setWheelStop = (winIndex: number): void => {
    this.midiStop = false;
    this.megaStop = false;
    let index: number = winIndex;
    switch (index) {
      case 2:
        this.midiStop = true;
        this.megaStop = false;
        break;

      case 3:
        this.midiStop = true;
        this.megaStop = true;
        break;
    }
    // console.log("JACKPOR WON INDEX ", winIndex)
  };
  private spinJackpotWheel = (
    stopAngle: number,
    wheelImg: PIXI.Container
  ): void => {
    // WheelAnimation Phases

    if (wheelImg == this.bigWheel) {
      highlightJackpotBox(this.activeGameData, [1, 1, 1]);
    } //disableMegaStar(this.activeGameData)};
    if (wheelImg == this.smallWheel) {
      highlightJackpotBox(this.activeGameData, [0, 1, 1]);
    }

    let wheelImage = wheelImg;
    this.tweeenAnticipation = PIXI.tweenManager.createTween(wheelImage); //Spring Back before start
    this.tweeenAnticipation
      .from({ rotation: (Math.PI / 180) * -9 })
      .to({ rotation: (Math.PI / 180) * -9 - (25 * Math.PI) / 180 });
    this.tweeenAnticipation.time = 100;
    if (wheelImage === this.bigWheel) {
      this.tweeenAnticipation.delay = 3500; //StartAfter 2 second
    } else {
      this.tweeenAnticipation.delay = 1000;
    }

    this.tweeenAnticipation.easing = PIXI.tween.Easing.outExpo();
    this.tweeenAnticipation.expire = true;
    this.tweeenAnticipation.start();

    //Action x spin x times
    this.tweeenAction = PIXI.tweenManager.createTween(wheelImage); //Spring Back before start
    this.tweeenAction.to({
      rotation:
        (this.maxSpinDefault * 360 * Math.PI) / 180 +
        (stopAngle * Math.PI) / 180,
    }); //spin 10 times
    this.tweeenAction.time = this.duration;

    this.tweeenAction.expire = true;
    this.tweeenAction.easing = PIXI.tween.Easing.outExpo();
    this.tweeenAction.stop();

    //Fin slowdown
    this.tweeenEnd = PIXI.tweenManager.createTween(wheelImage); //spin 360 before stop
    this.tweeenEnd.to({
      rotation:
        (this.maxSpinDefault * 360 * Math.PI) / 180 +
        (stopAngle * Math.PI) / 180,
    });
    this.tweeenEnd.time = this.tweeenAction.time * 0.2;

    this.tweeenEnd.expire = true;
    this.tweeenEnd.easing = PIXI.tween.Easing.linear();
    this.tweeenEnd.stop();
    //ANTICIPATIO TO ACTION SWITCH
    this.tweeenAnticipation.on(
      "update",
      function(tween: PIXI.tween.Tween) {
        if (this.elapsedTime > this.time * 0.99) {
          this.stop();
          tween.start();
          // console.log("LONG animationStarted",this.elapsedTime)
        }
        // tween.start();
        // console.log(elapsedTime)
      }.bind(this.tweeenAnticipation, this.tweeenAction)
    );

    //ACTION TO END SWITCH
    this.tweeenAction.on(
      "update",
      function(tween: PIXI.tween.Tween) {
        // console.log(wombody.rotation/Math.PI*180);
        if (this.elapsedTime > this.time * 0.95) {
          this.stop();
          tween.start();
        }
      }.bind(this.tweeenAction, this.tweeenEnd)
    );

    //--------------BIG WHEEEL MANAGE

    if (wheelImg === this.bigWheel && this.midiStop) {
      //if firs wheel spin and stop on arrow ==>start second wheel animation
      this.tweeenEnd.on(
        "end",
        function(self: JackpotWheel) {
          self.spinSecondWheel = true;
          self.spinHandlerBigWheel();
        }.bind(this.tweeenEnd, this)
      );
    } else if (wheelImg === this.bigWheel && this.midiStop === false) {
      //Win mini pot : display score
      //Start BlackOutAnimation

      // console.log("WIN MINI")
      this.tweeenEnd.on(
        "end",
        function(self: JackpotWheel) {
          self.blackCircleHighlightAnimation(1);
          self.spinSecondWheel = false;

          highlightJackpotBox(self.activeGameData, [1, 0, 0]);
        }.bind(this.tweeenEnd, this)
      );
    }

    //--------------SMALL WHEEEL MANAGE

    if (wheelImg === this.smallWheel && this.megaStop) {
      //if firs wheel spin and stop on arrow ==>start second wheel animation
      this.tweeenEnd.on(
        "end",
        function(self: JackpotWheel) {
          // self.megapotExplosion=true;
          self.spinHandlerSmallWheel();
        }.bind(this.tweeenEnd, this)
      );
    } else if (wheelImg === this.smallWheel && this.megaStop === false) {
      //Win midi pot
      //Start BlackOutAnimation
      this.tweeenEnd.on(
        "end",
        function(self: JackpotWheel) {
          // this.megapotExplosion=false;
          self.spinHandlerSmallWheel();
        }.bind(this.tweeenEnd, this)
      );
    }
  };

  private spinHandlerBigWheel = (): void => {
    //darken the Main Wheeel

    //Reveil the Midi Wheel
    this.blackCircleHighlightAnimation(1);
    this.smallWheelMask.setDuration(2000);
    this.smallWheelMask.setFadeInOutBlack(false);
    // console.log(this.spinSecondWheel)
    if (this.spinSecondWheel) {
      // console.log("MIDI")
      let fadeTween = this.smallWheelMask.getFadeTween();
      fadeTween.on(
        "end",
        function(self: JackpotWheel) {
          if (self.spinSecondWheel) {
            self.spinSecondWheel = false;
            self.startSpinSecondWheel();
          }
        }.bind(this.tweeenEnd, this)
      );
      if (this.megaStop) {
        // this.megapotExplosion=true;
      }
    } else {
      //won minipot
      // console.log("MINI")
      // this.winScoreDisplay.setVisibile(true);// .displayIN()
      // highlightJackpotBox(this.activeGameData, [1, 0, 0]);
    }
  };
  private spinHandlerSmallWheel = (): void => {
    //Reveil the Midi Wheel
    this.blackCircleHighlightAnimation(2);

    //If won mega Win start the light gathering animation around core
    if (this.megaStop) {
      this.explositonAnticipationTween.reset();
      this.explositonAnticipationTween.start();
    }
  };
  private blackCircleHighlightAnimation = (wheelIndex: number): void => {
    if (wheelIndex === 1) {
      this.bigWheelMask.setStartAnimationDegree(9);

      //Display the lignten arrow if the wheel stops on arrow
      if (this.midiStop) {
        this.bigWheelArrowOnTween.reset();
        this.bigWheelArrowOnTween.start();

        this.sound_swoosh.play("swoosh");
      } else {
        //display Minipot score
        // this.winScoreDisplay.displayIN();
        this.winScoreDisplay.setVisibile(true);

        this.activeGameData.jumpCoin.startJump();
      }
    } else if (wheelIndex === 2) {
      this.sound_swoosh.play("swoosh");
      if (this.megaStop) {
        this.arrowSmallWheel.gotoAndPlay(10);
        this.sound_arrowSound.play("arrow");
        this.arrowSmallWheel.alpha = 1;
        this.arrowBigWheel.gotoAndPlay(10);

        //turn on the arrow light
        this.smallWheelArrowOnTween.reset();
        this.smallWheelArrowOnTween.start();

        //start the masking the wheel and reveiling the core and play explosion animation on explosion over
        this.smallWheelMask.setStartAnimationDegree(9);
        this.coreMask.setFadeInOutBlack(false);
        // console.log("Loop")  ;

        // this.coreMask.darkenBodyLeftFadeTween.on('end',  function(self:JackpotWheel)
        // {
        //     this.stop();
        //     // console.log("Loop")
        //     // console.log(this)
        //     self.playCoreExplosion();
        //     self.winScoreDisplay.displayIN(3);
        //     self.activeGameData.jumpCoin(100);

        //     }.bind(this.coreMask.darkenBodyLeftFadeTween,this))

        setTimeout(() => {
          this.playCoreExplosion();
          // this.winScoreDisplay.displayIN();
          this.winScoreDisplay.setVisibile(true);
          highlightJackpotBox(this.activeGameData, [0, 0, 1]);
          // this.activeGameData.jumpCoin(100);
          // this.activeGameData.jumpCoin.startJump()
          jackpotCoinsJump(this.activeGameData, 3);
        }, 1200);
      } else {
        // this.smallWheelMask.fadeInBlack();
        this.smallWheelMask.setStartAnimationDegree(27);
        // this.winScoreDisplay.displayIN();
        this.winScoreDisplay.setVisibile(true);
        highlightJackpotBox(this.activeGameData, [0, 1, 0]);
        // this.activeGameData.jumpCoin.startJump()
        jackpotCoinsJump(this.activeGameData, 1);
      }
    }
  };
  private playCoreExplosion = (): void => {
    this.orbExplosionAnimationTween.reset();
    this.orbExplosionAnimationTween.start();
    this.sound_glassBreak.play("glassbreak");

    this.orbExplosionAnimation.gotoAndPlay(0);
    this.orbExplosionAnimation.alpha = 1;
    this.orbDefaultAnimation.stop();
    this.orbDefaultAnimation.alpha = 0;
    this.orbBroken.alpha = 1;

    this.jackpotmegaJackpotText.alpha = 0;
    // console.log("EXPLOSION")
  };
  private startSpinSecondWheel = (): void => {
    this.spinJackpotWheel(
      this.getSmallWheelStopAngle(this.megaStop),
      this.smallWheel
    );
    this.arrowBigWheel.play();
    this.arrowBigWheel.alpha = 1;

    //play jackpot arrowsound;
    this.sound_arrowSound.play("arrow");
  };
  private createWheel = (
    list: Array<PIXI.Sprite>,
    deltaAngle: number,
    copies: number,
    parent: PIXI.Container,
    imgName: PIXI.Texture,
    xOffset: number
  ): void => {
    for (var i = 0; i < copies; i++) {
      list[i] = new PIXI.Sprite(imgName);
      //img.anchor.set(1);
      list[i].anchor.x = xOffset;
      // list[i].anchor.y=(.991);
      list[i].anchor.y = 0.999;

      list[i].rotation = (deltaAngle * i * Math.PI) / 180;
      parent.addChild(list[i]);
    }
    parent.x = this.activeGameData.size[0] / 2;
    parent.y = this.activeGameData.size[1] / 2;

    parent.cacheAsBitmap = true;
  };

  private createInOutTween = (): void => {
    this.wheelContainerIN.from({ alpha: 0 }).to({ alpha: 1 });
    this.wheelContainerIN.time = 500;
    this.wheelContainerIN.easing = PIXI.tween.Easing.outBack();

    this.wheelContainerOut.from({ alpha: 1 }).to({ alpha: 0 });
    this.wheelContainerOut.time = 1;
    this.wheelContainerOut.easing = PIXI.tween.Easing.outBack();

    //tween Wheels
    this.wheelFrameIN
      .from({ alpha: 0, y: this.wheelFrame.y - 100 })
      .to({ alpha: 1, y: this.wheelFrame.y });
    this.wheelFrameIN.time = 1000;
    this.wheelFrameIN.easing = PIXI.tween.Easing.outBack();

    this.wheelFrameOut
      .from({ alpha: 1, y: this.wheelContainer.y - 100 })
      .to({ alpha: 0, y: this.wheelFrame.y - 100 });
    this.wheelFrameOut.time = 1;
    this.wheelFrameOut.easing = PIXI.tween.Easing.outBack();
  };

  private resetWheel = (): void => {
    this.wheelContainer.alpha = 0;
    this.arrowBigWheel.stop();
    this.arrowBigWheel.alpha = 0;
    this.arrowSmallWheel.stop();
    this.arrowSmallWheel.alpha = 0;
    this.smallWheelArrowOn.alpha = 0;
    this.bigWheelArrowOn.alpha = 0;
    //rebuild the broken
    this.orbDefaultAnimation.stop();
    this.orbDefaultAnimation.alpha = 0;
    //reset the black mask so that the midi ring and the core are hidden when restarting jackpot wheel animation//
    this.bigWheelMask.setFadeInOutBlack(false);
    this.smallWheelMask.setFadeInOutBlack(true);
    this.coreMask.setFadeInOutBlack(true);
    // this.smallWheelMask.resetRotations();
  };
  private stopWheelAnimations = (): void => {
    this.resetWheel();
  };

  public setWheelWin = (winIndex: number): void => {
    // this.setWheelStop(midiWin, megaWin);//-----------------------------------------------------------------------Set it by server
    this.setWheelStop(winIndex);
    this.spinJackpotWheel(
      this.getBigWheelStopAngle(this.midiStop),
      this.bigWheel
    );
    // console.log(midiWin,megaWin)
  };
  public startInAnimation = (): void => {
    // this.wheelContainer.alpha=1;
    this.jackpotmegaJackpotText.alpha = 0.5;
    this.wheelContainerIN.reset();
    this.wheelContainerIN.start();

    this.resetWheel();

    this.orbDefaultAnimation.play();
    this.orbDefaultAnimation.alpha = 1;
  };

  public stop = (): void => {
    this.tweeenEnd.off("end", null);
    this.wheelContainer.alpha = 0;
    this.wheelContainerOut.stop();
    this.stopWheelAnimations();
    this.smallWheelMask.setDefaultRotation();
    this.bigWheelMask.setDefaultRotation();
    this.setInitailRotation();
    this.activeGameData.resetAllBtns(this.activeGameData);
    displayJackpotBGCounter(this.activeGameData, true);
    this.winScoreDisplay.stop();

    this.bigWheelArrowOnTween.stop();
    this.smallWheelArrowOnTween.stop();
    this.pointerDefaultAnimation.stop();
    this.explositonAnticipationTween.stop();
    this.arrowBigWheel.stop();
    this.arrowSmallWheel.stop();
    this.orbExplosionAnimation.stop();
    this.orbExplosionAnimationTween.stop();
    this.tweeenAnticipation.stop();
    this.tweeenAction.stop();
    this.tweeenEnd.stop();
    this.wheelFrameIN.stop();
    this.wheelFrameOut.stop();
    this.wheelContainerIN.stop();
    this.wheelContainerOut.stop();

    this.sound_swoosh.stop();
    this.sound_arrowSound.stop();
    this.sound_glassBreak.stop();
  };

  public startOutAnimation = (): void => {
    this.wheelContainer.alpha = 1;
    this.wheelContainerOut.reset();
    this.wheelContainerOut.start();
    this.stopWheelAnimations();
    this.smallWheelMask.setDefaultRotation();
    this.bigWheelMask.setDefaultRotation();
    this.setInitailRotation();

    //reset btn that are clickable
    this.activeGameData.resetAllBtns(this.activeGameData);
    displayJackpotBGCounter(this.activeGameData, true);
  };
  public setPositionAndParent = (
    parent: PIXI.Container,
    posX: number,
    posY: number
  ): void => {
    this.wheelContainer.addChild(this.bigWheel);
    this.wheelContainer.addChild(this.bigWheelArrowOn);
    this.wheelContainer.addChild(this.wheelGradientLightBig);
    this.bigWheelMask.setParent(this.wheelContainer);
    this.wheelContainer.addChild(this.smallWheel);
    this.wheelContainer.addChild(this.smallWheelArrowOn);
    this.wheelContainer.addChild(this.wheelGradientLightSmall);
    this.smallWheelMask.setParent(this.wheelContainer);
    this.wheelContainer.addChild(this.explositonAnticipation);
    this.wheelContainer.addChild(this.wheelFrame);
    this.wheelContainer.addChild(this.orbBroken);
    this.wheelContainer.addChild(this.orbDefaultAnimation);
    this.coreMask.setParent(this.wheelContainer);
    this.wheelContainer.addChild(this.orbExplosionAnimation);
    this.wheelContainer.addChild(this.jackpotmegaJackpotText);
    this.orbExplosionAnimation.alpha = 0;
    this.orbBroken.alpha = 0;
    this.wheelContainer.addChild(this.pointerDefaultAnimation);
    this.pointerDefaultAnimation.play();
    // this.orbDefaultAnimation.play();
    this.wheelContainer.addChild(this.arrowBigWheel);
    this.wheelContainer.addChild(this.arrowSmallWheel);
    this.winScoreDisplay.setParent(this.wheelContainer);
    this.winScoreDisplay.setBodytTweenInReset();
    parent.addChild(this.wheelContainer);
    this.wheelContainer.x = posX;
    this.wheelContainer.y - posY;
    this.createInOutTween();

    this.smallWheelMask.setDefault();
    this.coreMask.setDefault();

    // this.smallWheelMask.setDuration(1);
    // this.smallWheelMask.setDefaultZero();
    // this.smallWheelMask.fadeInBlack();
    // this.coreMask.setDuration(1);
    // this.coreMask.setDefaultZero();
    // this.coreMask.fadeInBlack();
    this.wheelContainer.alpha = 0;
  };

  public getWinScreen = (): WinScreen => {
    return this.winScoreDisplay;
  };
  // displayscore()
  // {
  //     // this.winScoreDisplay.displayOut();
  //     this.winScoreDisplay.setVisibile(false)
  // }

  // private resetScoreTween()
  // {
  //     this.resetScoreTween();
  // }
}
